<template>
  <v-col cols="12" :md="colMd">
    <v-row dense align="start" class="stock-incoterm-fields ma-0 flex-nowrap">
      <v-col :cols="incotermCols" class="py-0 pl-0">
        <v-autocomplete
          :value="incotermId"
          :items="incotermOptions"
          :item-text="itemText"
          :item-value="itemValue"
          :label="$t('GENERAL.LABELS.INCOTERMS')"
          :disabled="incotermDisabled"
          clearable
          hide-details="auto"
          v-bind="incotermAttrs"
          v-on="incotermListeners"
          @input="$emit('update:incotermId', $event)"
        ></v-autocomplete>
      </v-col>
      <v-col :cols="namedPlaceCols" class="py-0 pr-0">
        <v-text-field
          :value="incotermNamedPlace"
          :label="$t('GENERAL.LABELS.INCOTERM_NAMED_PLACE')"
          :disabled="resolvedNamedPlaceDisabled"
          clearable
          hide-details="auto"
          v-bind="namedPlaceAttrs"
          v-on="namedPlaceListeners"
          @input="$emit('update:incotermNamedPlace', $event)"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: "StockIncotermFields",
  inheritAttrs: false,
  props: {
    incotermId: {
      type: [Number, String],
      default: null,
    },
    incotermNamedPlace: {
      type: String,
      default: null,
    },
    incotermOptions: {
      type: Array,
      default: () => [],
    },
    incotermDisabled: {
      type: Boolean,
      default: false,
    },
    namedPlaceDisabled: {
      type: Boolean,
      default: undefined,
    },
    colMd: {
      type: [Number, String],
      default: 5,
    },
    incotermCols: {
      type: [Number, String],
      default: 5,
    },
    namedPlaceCols: {
      type: [Number, String],
      default: 7,
    },
    itemText: {
      type: String,
      default: "label",
    },
    itemValue: {
      type: String,
      default: "id",
    },
    incotermAttrs: {
      type: Object,
      default: () => ({}),
    },
    namedPlaceAttrs: {
      type: Object,
      default: () => ({}),
    },
    incotermListeners: {
      type: Object,
      default: () => ({}),
    },
    namedPlaceListeners: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    resolvedNamedPlaceDisabled() {
      if (this.namedPlaceDisabled !== undefined) {
        return this.namedPlaceDisabled;
      }
      return this.incotermDisabled;
    },
  },
};
</script>

<style scoped>
.stock-incoterm-fields.flex-nowrap {
  flex-wrap: nowrap;
}
</style>
